import DatePicker from "vue2-datepicker";
import moment, { months } from "moment";
import MenuRightSerivce from "@/service/MenuRightService";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import StoreGetter from "@/constants/StoreGetter";
import Settings from "../../../constants/Settings";
import { PayrollTrial } from "@/model/PayrollTrial";
import { datePickerLang } from "@/constants/globalConstants";
import PayGroupService from "@/service/PayGroupService";
import StaffEmploymentService from "@/service/StaffEmploymentService";
import ArrayHelper from "../../../common/helper/ArrayHelper";
import CompanyService from "../../../service/CompanyService";
import PayrollAdjustmentService from "../../../service/PayrollAdjustmentService";
import SweetAlertService from "../../../service/SweetAlertService";
import PayProfileService from "@/service/PayProfileService";
import { PayAdj } from "../../../model/PayAdj";
import TreeNodeHelper from "../../../common/helper/TreeNodeHelper";
import PayrollAdjustmentVal from "./PayrollAdjustmentVal.js";
import ImportFile from "@/components/FileReader";
const PayrollAdjustmentObj = new PayrollAdjustmentVal();
export default {
    name: "PayrollAdjustment",
    components: {
        DatePicker,
        moment,
        ImportFile
    },
    data() {
        return {
            menuRights: { allRights: {}, rightsForThisMenu: {} },
            menuId: Settings.MenuID.PayrollAdjustment,
            Settings: Settings,
            dictEnum: dictEnum,
            lang: datePickerLang,
            searchRecord: {
                Month: moment().format("YYYY-MM-DD"),
                CompCode: "",
                Dept: "",
                PayGroup: ""
            },
            mode: "Update",
            modeList: {
                update: "Update",
                add: "Add"
            },
            compList: [],
            deptList: [],
            payGrpList: [],
            selectedRecord: new PayAdj(),
            staffList: [],
            adjustmentList: [],
            tableData: [],
            adjustmentHeaders: [
                {
                    key: "Expan",
                    label: '',
                    thStyle: "width:2%",
                },
                {
                    key: "CompCode",
                    label: t.t(dictEnum.LBL_Company),
                    thStyle: "width:10%",
                },
                {
                    key: "StaffID",
                    label: t.t(dictEnum.LBL_StaffID),
                    thStyle: "width:10%",
                },
                {
                    key: "StaffName",
                    label: t.t(dictEnum.LBL_Name),
                    thStyle: "width:10%",
                },
                {
                    key: "JobTitle",
                    label: t.t(dictEnum.LBL_JobTitle),
                    thStyle: "width:10%",
                },
                {
                    key: "EmpType",
                    label: t.t(dictEnum.LBL_EmpType),
                    thStyle: "width:10%",
                },
                {
                    key: "DateTx",
                    label: t.t(dictEnum.LBL_Date),
                    thStyle: "width:10%",
                },
                {
                    key: "AdjAdd",
                    label: '+ / -',
                    thStyle: "width:5%",
                },
                {
                    key: "IncSubType",
                    label: t.t(dictEnum.LBL_IncSubType),
                    thStyle: "width:10%;",
                },
                {
                    key: "Particulars",
                    label: t.t(dictEnum.LBL_Particular),
                    thStyle: "width:10%",
                },
                {
                    key: "Amt",
                    label: t.t(dictEnum.LBL_Amount),
                    thStyle: "width:5%",
                },
                {
                    key: "Action",
                    label: '',
                    thStyle: "width:5%",
                }
            ],
            incTypeList: []
        };
    },
    computed: {
        t() {
            return t;
        },
        user() {
            return this.$store.getters[StoreGetter.user];
        },
        updateMode() {
            return this.mode == this.modeList.update
        },
        IncTypes() {
            const list = this.incTypeList;
            const datas = ArrayHelper.uniqueBykey(list, 'IncTypeDesc');;
            return datas;
        }
    },

    mounted() {
        PayrollAdjustmentObj.PayrollAdjustmentVal();
        this.assignRights();
        this.getCompList();
        this.getDeptList();
        this.getPayGroupList();
        this.getAllPayProfile();
        this.searchDataClick();
        this.getIncTypeList()
    },

    methods: {
        hasRight(key, menuId) {
            if (Object.keys(this.menuRights.allRights).length === 0) {
                return false;
            } else {
                return MenuRightSerivce.hasRightInMenu(
                    this.menuRights.allRights,
                    menuId ? menuId : this.menuId,
                    key
                );
            }
        },
        assignRights() {
            this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];

            this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
                x => x.MenuID == this.menuId
            );
        },

        formatAmt(e) {
            return String(e).substring(0, 10);
        },

        rowClass(item, type) {
            if (!item || type !== 'row') return
            if (item.DateTx == this.selectedRecord.DateTx && item.StaffID == this.selectedRecord.StaffID) {
                return 'selected-tr'
            }
        },

        initData() {
        },

        async getCompList() {
            var obj = {
                take: 100,
                skip: 0,
            }
            const response = await CompanyService.getAllCompanyList(obj);
            if (response.data.IsSuccess) {
                this.compList = response.data.Data.Item1;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },

        async getDeptList() {
            var obj = {}
            const response = await StaffEmploymentService.getAllDepartment(obj);
            if (response.data.IsSuccess) {
                this.deptList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },

        async getIncTypeList() {
            const obj = {};
            const response = await PayrollAdjustmentService.getIncTypeList(obj);
            if (response) {
                this.incTypeList = response.data.Data
            } else {
                SweetAlertService.warning("Warn", response.data.Message)
            }
        },


        async getAllPayProfile() {
            var obj = {
                Company: this.searchRecord.CompCode,
                Dept: this.searchRecord.Dept,
                PayGroup: this.searchRecord.PayGroup,
                PayType: ""
            };
            const response = await PayProfileService.getAllPayProfile(obj);
            if (response.data.IsSuccess) {
                this.staffList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },

        async getPayGroupList() {
            var obj = {}
            const response = await PayGroupService.getAllPayGroup(obj);
            if (response.data.IsSuccess) {
                this.payGrpList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },

        async searchDataClick() {
            const obj = {
                date: moment(this.searchRecord.Month).format(Settings.DateTime.yyyymmdd),
                company: this.searchRecord.CompCode,
                dept: this.searchRecord.Dept,
                payGroup: this.searchRecord.PayGroup
            }
            const response = await PayrollAdjustmentService.getPayAdjList(obj);
            if (response.data.IsSuccess) {
                this.tableData = response.data.Data
                response.data.Data.forEach((x) => x.Other = [])
                const result = this.GroupByKey(response.data.Data, 'StaffID', 'Other');
                this.adjustmentList = result;
            } else {
                SweetAlertService.warning("Warn", response.data.Message)
            }

        },

        GroupByKey(array, key, other) {
            let list = []
            array.reduce((rv, x) => {
                const find = list.find((data) => x[key] == data[key]);
                if (find) {
                    find[other].push(x)
                } else {
                    list.push(x)
                }
            }, {});
            return list
        },

        async ExportItems() {
            var XLSX = require("xlsx");
            if (!XLSX) return;
            let list = [];
            for (let data of this.tableData) {
                const obj = {
                    Company: data.CompCode,
                    StaffID: data.StaffID,
                    StaffName: data.StaffName,
                    JobTitle: data.JobTitle,
                    EmpType: data.EmpType,
                    DateTx: moment(data.DateTx).format(Settings.DateTime.yyyymmddhhmmss),
                    AdjAdd: data.AdjAdd ? "+" : "-",
                    IncType: data.IncType,
                    IncSubType: data.IncSubType,
                    Particulars: data.Particulars,
                    Amt: data.Amt,
                }
                list.push(obj)
            }
            const worksheet = await XLSX.utils.json_to_sheet(
                list
            );
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet);
            XLSX.writeFile(
                workbook,
                `${t.t(dictEnum.LBL_PayrollAdjustment)}_${moment().format("YYYY-MM-DD HH:mm")}.xlsx`
            );
        },

        ImportItems() {
            var XLSX = require("xlsx");
            const input = $("#fileReader");
            let reader = new FileReader();
            reader.readAsBinaryString(input[0].files[0]);
            reader.onload = async e => {
                let workbook = XLSX.read(e.target.result, { type: "binary", });
                let sheetList = workbook.SheetNames;
                let rows = XLSX.utils.sheet_to_json(workbook.Sheets[sheetList[0]], { defval: "" })
                rows = rows.map((obj) => Object.values(obj));
                let TimeCardObj = [];
                for (let row of rows) {
                    let temp;
                    temp = {
                        Company: row[0],
                        StaffID: row[1],
                        StaffName: row[2],
                        JobTitle: row[3],
                        EmpType: row[4],
                        DateTx: moment(row[5]).format(Settings.DateTime.yyyymmdd),
                        AdjAdd: row[6] == '+',
                        IncType: row[7],
                        IncSubType: row[8],
                        Particulars: row[9],
                        Amt: row[10],
                    }
                    TimeCardObj.push(temp)
                }

                const response = await PayrollAdjustmentService.importPayAdjList({
                    models: TimeCardObj,
                });
                if (response.data.IsSuccess) {
                    SweetAlertService.success("Success", response.data.Message);
                } else {
                    SweetAlertService.warning("Warn", response.data.Message);
                }
            }
        },

        changeStaff() {
            const user = this.staffList.find((x) => x.StaffID == this.selectedRecord.StaffID);
            if (user) {
                this.selectedRecord.CompCode = user.CompCode;
                this.selectedRecord.JobTitle = user.JobTitle;
                this.selectedRecord.EmpType = user.EmpType;
                this.selectedRecord.StaffName = this.user.Lang == 'EN' ? user.EName : user.CName
            }
        },

        AddItem() {
            this.$bvModal.show("ModalItem")
            this.mode = this.modeList.add;
            this.selectedRecord = new PayAdj()
        },

        editPayAdj(item) {
            this.$bvModal.show("ModalItem")
            this.mode = this.modeList.update;
            let data = JSON.parse(JSON.stringify(item))
            data.DateTx = moment(data.DateTx).format(Settings.DateTime.yyyymmdd)
            this.selectedRecord = data;
        },

        async deletePayAdj(item) {
            const obj = {
                staffID: item.StaffID,
                date: moment(item.DateTx).format(Settings.DateTime.yyyymmdd),
                seq: item.Seq
            };

            const sweetAlertOptions = {
                title: this.t.t(dictEnum.WARN_Confirm),
                text: `${t.t(dictEnum.WARN_Delete)}`,
                cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
                confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
            };
            const result = await SweetAlertService.question(sweetAlertOptions);
            if (result.value) {
                const response = await PayrollAdjustmentService.deletePayAdj(obj);
                if (response.data.IsSuccess) {
                    SweetAlertService.success("Success", response.data.Message)
                    this.searchDataClick()
                } else {
                    SweetAlertService.warning("Warn", response.data.Message)
                }
            }
        },


        async AddOrUpdate() {
            this.$validator.validateAll().then(async result => {
                if (result) {
                    this.$bvModal.hide("ModalItem");
                    const inctype = this.incTypeList.find((x) => x.IncSubType == this.selectedRecord.IncSubType);
                    if (inctype) {
                        this.selectedRecord.IncType = inctype.IncTypeDesc
                    }
                    const obj = {
                        model: this.selectedRecord
                    };
                    const response = await PayrollAdjustmentService.savePayAdj(obj);
                    if (response.data.IsSuccess) {
                        SweetAlertService.success("Success", response.data.Message);
                        this.searchDataClick()
                    } else {
                        SweetAlertService.warning("Warn", response.data.Message);
                    }
                }
            })
        }
    },
};


// WEBPACK FOOTER //
// ./src/components/100000-Payroll/103000-PayrollAdjustment/103000-PayrollAdjustment.js